import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export interface NavSubmenuItem {
  id: string | number;
  label: string;
}

export interface NavSubmenuConfig {
  items: NavSubmenuItem[];
  placeholder?: string;
  defaultSelected?: string | number;
  title?: string;
  maxItemsVisibility?: number;
  visible?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NavSubmenuService {
  private selectedValueSubject = new BehaviorSubject<string | number | undefined>(undefined);
  private configSubject = new BehaviorSubject<NavSubmenuConfig | null>(null);
  
  selectedValue$ = this.selectedValueSubject.asObservable();
  config$ = this.configSubject.asObservable();
  
  readonly selectedItem$ = combineLatest([this.config$, this.selectedValue$]).pipe(
    map(([config, selectedValue]) => {
      if (!config || !selectedValue) return null;
      return config.items.find(item => item.id === selectedValue) || null;
    })
  );
  
  setSubmenu(config: NavSubmenuConfig): void {
  this.configSubject.next(config);
  if (config.defaultSelected && !this.selectedValueSubject.value) {
    this.selectedValueSubject.next(config.defaultSelected);
  }
}
  
  clearSubmenu(): void {
    this.configSubject.next(null);
    this.selectedValueSubject.next(undefined);
  }
  
  updateSelection(value: string | number): void {
    this.selectedValueSubject.next(value);
  }
  
  getCurrentSelection(): string | number | undefined {
    return this.selectedValueSubject.value;
  }
  
  getCurrentConfig(): NavSubmenuConfig | null {
    return this.configSubject.value;
  }
}